import * as THREE from 'three';

/** Form 3 build volume in millimetres. */
export const BUILD_VOLUME = { width: 145, depth: 145, height: 185 };

export function createBuildVolume(): THREE.Group {
  const { width, depth, height } = BUILD_VOLUME;
  const group = new THREE.Group();
  const lineMaterial = new THREE.LineBasicMaterial({ color: '#8b9096' });

  const volume = new THREE.LineSegments(new THREE.EdgesGeometry(new THREE.BoxGeometry(width, height, depth)), lineMaterial);
  volume.position.y = height / 2;
  group.add(volume);

  const plateGeometry = new THREE.BoxGeometry(width + 6, 3, depth + 6);
  const plate = new THREE.Mesh(plateGeometry, new THREE.MeshStandardMaterial({ color: '#f3f4f5', roughness: 0.95 }));
  plate.position.y = -1.55;
  group.add(plate);

  const plateEdges = new THREE.LineSegments(new THREE.EdgesGeometry(plateGeometry), lineMaterial);
  plateEdges.position.copy(plate.position);
  group.add(plateEdges);

  const grid = new THREE.GridHelper(width, 14, '#9a9fa5', '#9a9fa5');
  grid.position.y = 0.05;
  group.add(grid);

  return group;
}
